const reducer = (state = {pages:{}}, action) => {
    switch (action.type) {
        case 'SET_SEARCH_PAGES':
			return {...state, pages: action.pages}
		default: // need this for default case
      		return state ;
    }
}

export default reducer;